// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2352":"338add9f","3341":"9c576cbd","6729":"a5a757ef","8680":"338add9f","8901":"9c576cbd","9628":"ffe73276"}[chunkId] + ".chunk.css";
};